import _defineProperty from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { domainCaption, isDiscrete } from 'vega-scale';
import { array, peek, toSet } from 'vega-util';
var ARIA_HIDDEN = 'aria-hidden';
var ARIA_LABEL = 'aria-label';
var ARIA_ROLE = 'role';
var ARIA_ROLEDESCRIPTION = 'aria-roledescription';
var GRAPHICS_OBJECT = 'graphics-object';
var GRAPHICS_SYMBOL = 'graphics-symbol';
var bundle = function bundle(role, roledesc, label) {
  return _defineProperty(_defineProperty(_defineProperty({}, ARIA_ROLE, role), ARIA_ROLEDESCRIPTION, roledesc), ARIA_LABEL, label || undefined);
};

// these roles are covered by related roles
// we can ignore them, no need to generate attributes
var AriaIgnore = toSet(['axis-domain', 'axis-grid', 'axis-label', 'axis-tick', 'axis-title', 'legend-band', 'legend-entry', 'legend-gradient', 'legend-label', 'legend-title', 'legend-symbol', 'title']);

// aria attribute generators for guide roles
var AriaGuides = {
  'axis': {
    desc: 'axis',
    caption: axisCaption
  },
  'legend': {
    desc: 'legend',
    caption: legendCaption
  },
  'title-text': {
    desc: 'title',
    caption: function caption(item) {
      return "Title text '".concat(titleCaption(item), "'");
    }
  },
  'title-subtitle': {
    desc: 'subtitle',
    caption: function caption(item) {
      return "Subtitle text '".concat(titleCaption(item), "'");
    }
  }
};

// aria properties generated for mark item encoding channels
export var AriaEncode = {
  ariaRole: ARIA_ROLE,
  ariaRoleDescription: ARIA_ROLEDESCRIPTION,
  description: ARIA_LABEL
};
export function ariaItemAttributes(emit, item) {
  var hide = item.aria === false;
  emit(ARIA_HIDDEN, hide || undefined);
  if (hide || item.description == null) {
    for (var prop in AriaEncode) {
      emit(AriaEncode[prop], undefined);
    }
  } else {
    var type = item.mark.marktype;
    emit(ARIA_LABEL, item.description);
    emit(ARIA_ROLE, item.ariaRole || (type === 'group' ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL));
    emit(ARIA_ROLEDESCRIPTION, item.ariaRoleDescription || "".concat(type, " mark"));
  }
}
export function ariaMarkAttributes(mark) {
  return mark.aria === false ? _defineProperty({}, ARIA_HIDDEN, true) : AriaIgnore[mark.role] ? null : AriaGuides[mark.role] ? ariaGuide(mark, AriaGuides[mark.role]) : ariaMark(mark);
}
function ariaMark(mark) {
  var type = mark.marktype;
  var recurse = type === 'group' || type === 'text' || mark.items.some(function (_) {
    return _.description != null && _.aria !== false;
  });
  return bundle(recurse ? GRAPHICS_OBJECT : GRAPHICS_SYMBOL, "".concat(type, " mark container"), mark.description);
}
function ariaGuide(mark, opt) {
  try {
    var item = mark.items[0],
      caption = opt.caption || function () {
        return '';
      };
    return bundle(opt.role || GRAPHICS_SYMBOL, opt.desc, item.description || caption(item));
  } catch (err) {
    return null;
  }
}
function titleCaption(item) {
  return array(item.text).join(' ');
}
function axisCaption(item) {
  var datum = item.datum,
    orient = item.orient,
    title = datum.title ? extractTitle(item) : null,
    ctx = item.context,
    scale = ctx.scales[datum.scale].value,
    locale = ctx.dataflow.locale(),
    type = scale.type,
    xy = orient === 'left' || orient === 'right' ? 'Y' : 'X';
  return "".concat(xy, "-axis") + (title ? " titled '".concat(title, "'") : '') + " for a ".concat(isDiscrete(type) ? 'discrete' : type, " scale") + " with ".concat(domainCaption(locale, scale, item));
}
function legendCaption(item) {
  var datum = item.datum,
    title = datum.title ? extractTitle(item) : null,
    type = "".concat(datum.type || '', " legend").trim(),
    scales = datum.scales,
    props = Object.keys(scales),
    ctx = item.context,
    scale = ctx.scales[scales[props[0]]].value,
    locale = ctx.dataflow.locale();
  return capitalize(type) + (title ? " titled '".concat(title, "'") : '') + " for ".concat(channelCaption(props)) + " with ".concat(domainCaption(locale, scale, item));
}
function extractTitle(item) {
  try {
    return array(peek(item.items).items[0].text).join(' ');
  } catch (err) {
    return null;
  }
}
function channelCaption(props) {
  props = props.map(function (p) {
    return p + (p === 'fill' || p === 'stroke' ? ' color' : '');
  });
  return props.length < 2 ? props[0] : props.slice(0, -1).join(', ') + ' and ' + peek(props);
}
function capitalize(s) {
  return s.length ? s[0].toUpperCase() + s.slice(1) : s;
}